import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-ac-ronald-weasley-the-burrow",
  name: `Ronald Weasley Acceptance Letter\n'The Burrow'`,
  nameFormatted: {
    primary: "Ronald Weasley Acceptance Letter",
    secondary: "'The Burrow'",
  },
  origin: `Harry Potter and the Philosopher's Stone`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
